/**
 * Created by Jerker Nord on 2018-12-04.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorReelSymbol} from "../../symbols/ThorReelSymbol";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class ThorMultiplierView extends BaseView {

    private _layer:ScalableLayer;

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.MULTIPLIER.name);
    }

    protected initAnimations():void {
        this._layer.addChild(this);
    }

    private getBonusSymbolPosition():PIXI.Point {
        let tempSymbol:ThorReelSymbol;
        let symbolPosition:[number, number];

        for(let i:number = 0; i < 4; i++) {
            tempSymbol = <ThorReelSymbol>Reels.getSymbol(4, i)!;
            if(tempSymbol.symName == "B") {
                symbolPosition = Helper.getSymbolPositions(4, i);
                break;
            }
        }

        return new PIXI.Point(symbolPosition![0], symbolPosition![1]);
    }
}